import { render, staticRenderFns } from "./Documento.vue?vue&type=template&id=262fd64f&scoped=true"
import script from "./Documento.vue?vue&type=script&lang=js"
export * from "./Documento.vue?vue&type=script&lang=js"
import style0 from "./Documento.vue?vue&type=style&index=0&id=262fd64f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262fd64f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('262fd64f')) {
      api.createRecord('262fd64f', component.options)
    } else {
      api.reload('262fd64f', component.options)
    }
    module.hot.accept("./Documento.vue?vue&type=template&id=262fd64f&scoped=true", function () {
      api.rerender('262fd64f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/documento/Documento.vue"
export default component.exports